import { Box, Typography } from '@mui/material';
import React from 'react';

const AdminSectionHeader: React.FC<{
  title: string;
  actions?: React.ReactElement;
}> = ({ title, actions }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
        position: 'sticky',
        top: 0,
        width: '100%',
        minHeight: '75px',
        backgroundColor: 'background.default',
        zIndex: 2,
      }}
    >
      <Typography variant='h2'>{title}</Typography>

      <Box
        style={{
          padding: '10px',
        }}
      >
        {actions != null && actions}
      </Box>
    </Box>
  );
};

export default AdminSectionHeader;
